import { useMemo } from 'react';

import { DocumentType } from '../generated-api';
import ocrResultPageDefinitions from '../page/OcrResult/defs';

export default function useOcrPageDefinition(type: DocumentType) {
  return useMemo(() => ocrResultPageDefinitions[type], [type]);
}
